import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useMemberStaleAwareData } from '../../Context/useMemberStaleAwareData';
import { NotificationBannerItem } from '../NotificationBanner';
import Icon from '../../common/Icon';

const useMissedPaymentAlert = () => {
  const navigate = useNavigate();
  const { data } = useMemberStaleAwareData();

  const [alerts, setAlerts] = useState<NotificationBannerItem[]>([]);

  const calculateAlerts = useCallback((): NotificationBannerItem[] => {
    if (!data?.invoice?.transactions) return [];

    const totalOverdueAmount = data.invoice.transactions
      .filter(t => t.isOverdue)
      .reduce((sum, t) => sum + t.amount, 0);

    if (totalOverdueAmount === 0) return [];

    return [
      {
        highlight: true,
        highlightOrder: 0,
        status: 'red',
        icon: <Icon name="warning" color="red" />,
        text: `Payment(s) overdue — £${totalOverdueAmount}`,
        buttonText: 'Pay now',
        onButtonClick: () => navigate('/myaccount/payments'),
      },
    ];
  }, [data, navigate]);

  const refresh = useCallback(() => {
    setAlerts(calculateAlerts());
  }, [calculateAlerts]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { alerts, refresh };
};

export default useMissedPaymentAlert;